import { useAuthenticationStore } from "../authentication";
import { api, client } from "@/client";
import ManageReportsModal from "@/components/Modal/ManageReportsModal.vue";
import { usePDF } from "@/stores/report_pdf";
import { Modal } from "bootstrap";
import { defineStore, acceptHMRUpdate } from "pinia";
import { PromiseDialog } from "vue3-promise-dialog";
import auth from "../../auth";

export const useTransferStore = defineStore("transfer", {
  state: () => ({
    totalRecordsWarning: 0 as Number,
    startingAfterWarning: "" as String | undefined,
    firstIdWarning: 0 as Number,
    totalRecordsCritical: 0 as Number,
    startingAfterCritical: "" as String | undefined,
    firstIdCritical: 0 as Number,
    totalRecordsNonCritical: 0 as Number,
    startingAfterNonCritical: "" as String | undefined,
    firstIdNonCritical: 0 as Number,
    totalRecordsSip: 0 as Number,
    loading: false,
    currentTransfer: {},
    transferList: {} as api.ListTransfersResponseBody,
    sipList: [] as Array<api.SIP>,
    packageList: [{}],
    currentSip: {} as api.SIP,
    currentTransferExceptionWarning: [{}] as Array<api.TransferException>,
    currentTransferExceptionCritical: [{}] as Array<api.TransferException>,
    currentTransferExceptionNonCritical: [{}] as Array<api.TransferException>,
    reportSummary: {},
    transferReportList: [{}] as Array<api.TransferReport>,
    accessTokenString : "" as String ,
    totalTransferReports: 0 as Number
  }),
  getters: {},
  actions: {
    async fetchTransfer(id: string) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsShowTransfer({ id })
        .then((payload) => {
          this.currentTransfer = payload;
          this.fetchTransferExceptionWarning(id, 20, "");
          this.fetchTransferExceptionCritical(id, 20, "");
          this.fetchTransferExceptionNonCritical(id, 20, "");
          // this.fetchTransferList(payload.batchId);
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async fetchTransferExceptionWarning(
      transferId: string,
      perPage: number,
      starting: string
    ) {
      this.loading = true;
      client.content
        .contentsListTransferExceptions({
          id: transferId,
          startingAfter: starting,
          limit: 1000,
          type: "Warning",
        })
        .then((payload) => {
          this.currentTransferExceptionWarning = payload.items;
          this.totalRecordsWarning = payload.totalCount;
          this.startingAfterWarning = payload.startingAfter;
          if (starting == "") {
            this.firstIdWarning = payload.items[0].id;
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    async fetchTransferExceptionCritical(
      transferId: string,
      perPage: number,
      starting: string
    ) {
      this.loading = true;
      client.content
        .contentsListTransferExceptions({
          id: transferId,
          startingAfter: starting,
          limit: 1000,
          type: "Critical Error",
        })
        .then((payload) => {
          this.currentTransferExceptionCritical = payload.items;
          this.totalRecordsCritical = payload.totalCount;
          this.startingAfterCritical = payload.startingAfter;
          if (starting == "") {
            this.firstIdCritical = payload.items[0].id;
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    async fetchTransferExceptionNonCritical(
      transferId: string,
      perPage: number,
      starting: string
    ) {
      this.loading = true;
      client.content
        .contentsListTransferExceptions({
          id: transferId,
          startingAfter: starting,
          limit: 1000,
          type: "Non-critical Error",
        })
        .then((payload) => {
          this.currentTransferExceptionNonCritical = payload.items;
          this.totalRecordsNonCritical = payload.totalCount;
          this.startingAfterNonCritical = payload.startingAfter;
          if (starting == "") {
            this.firstIdNonCritical = payload.items[0].id;
          }
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    async transferNote(id: string, msg: string) {
      this.$reset();
      client.content
        .contentsAddTransferNote({
          id,
          addTransferNoteRequestBody: { note: msg },
        })
        .then((payload) => {
          console.log("Msg:", payload, id);
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.transferNote(id, msg);
          }
        })
        .finally(() => {
          this.fetchTransfer(id);
        });
    },

    async deleteBatchNote(id: string) {
      this.$reset();
      client.content
        .contentsDeleteTransferNote({ id })
        .then((payload) => {
          console.log("Msg Deleted:", payload, id);
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.deleteBatchNote(id);
          }
        })
        .finally(() => {
          this.fetchTransfer(id);
        });
    },

    // async fetchTransferList(batchId: number) {
    //   this.$reset;
    //   client.content
    //     .contentsTransfers({ batchId })
    //     .then((payload) => {
    //       console.log("fetchTransferList", batchId, payload);
    //       for (let i = 0; i < payload.items.length; i++) {
    //         if (payload.items[i].batchId == batchId) {
    //           this.transferList = payload.items[i];
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       return error;
    //     });
    // },

    async fetchSip(
      id: string,
      perPage: number,
      sort: string,
      filters: Array<any>
    ) {
      this.loading = true;
      client.content
        .contentsListTransferSips({
          id,
          name: filters[0].filterText,
          status: filters[1].filterText,
          ordering: sort as api.ContentsListTransferSipsOrderingEnum,
          limit: 1000,
        })
        .then((payload) => {
          this.sipList = payload.items;
          this.totalRecordsSip = payload.totalCount;
        })
        .finally(() => {
          this.currentSip = this.sipList[0];
          this.loading = false;
        })
        .catch((error) => {
          return error;
        });
    },

    async fetchCurrentSip(params: any) {
      this.currentSip = params.row;
    },

    async approveTransfer(id: string) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsApproveTransfer({ id })
        .then((payload) => {
          console.log("Approve:", payload, id);
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.approveTransfer(id);
          }
        })
        .finally(() => {
          this.loading = false;
          this.fetchTransfer(id);
        });
    },

    async rejectTransfer(id: string) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsRejectTransfer({ id })
        .then((payload) => {
          console.log("Reject:", payload, id);
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.rejectTransfer(id);
          }
        })
        .finally(() => {
          this.loading = false;
          this.fetchTransfer(id);
        });
    },

    async retryTransfer(id: string) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsRetryTransfer({ id })
        .then((payload) => {
          console.log("Retry:", payload, id);
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.retryTransfer(id);
          }
        })
        .finally(() => {
          this.loading = false;
          this.fetchTransfer(id);
        });
    },

    async reprocessSip(sipId: [], id: string, selectedWorkflow, message, emit) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsChangeTransferWorkflow({
          id,
          changeTransferWorkflowRequestBody: { workflowId: selectedWorkflow },
        })
        .then((payload) => {
          console.log(
            "Reprocess:",
            payload,
            "transferId:",
            id,
            "sipId:",
            sipId,
            "workflow:",
            selectedWorkflow,
            "message:",
            message
          );
        })
        .catch((error) => {
          let ok = confirm(error.message + ", Do you want to try again? ");
          if (ok) {
            this.reprocessSip(sipId, id, selectedWorkflow, message, emit);
          }
        })
        .finally(() => {
          this.loading = false;
          this.fetchSip(id, 20, "", []);
        });
    },

    async transferReportTable(id: string) {
      this.loading = true;
      client.content.contentsDownloadTransferReport({ id, reportType: "summary" })
      .then((blob) => {
        // Read the Blob as text
        const reader:any = new FileReader();
        reader.onload = () => {
          try {
            // Parse the text content as JSON
            const json = JSON.parse(reader.result);
            // Now you have the JSON data
            this.reportSummary = json;
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        };
        reader.onerror = (error) => {
          console.error("Error reading Blob:", error);
        };
        reader.readAsText(blob);
      })
      .finally(() => (this.loading = false))
      .catch((error) => {
        return error;
      });    


      // fetch(
      //   import.meta.env.VITE_SERVER_HOST +
      //     "/contents/transfers/" +
      //     id +
      //     "/report?report_type=summary",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      //   .then((res) => {
      //     res.json().then((json) => {
      //       this.reportSummary = json;
      //     });
      //     console.log("tyuyy")
      //   })
      //   .finally(() => (this.loading = false))
      //   .catch((error) => {
      //     return error;
      //   });
    },

    async transferReportSummary(id: string) {
      this.loading = true;
      client.content.contentsDownloadTransferReport({ id, reportType: "summary" })
        .then((blob) => {
          return new Promise((resolve, reject) => {
            const reader:any = new FileReader();
            reader.onload = () => {
              try {
                const json:any = JSON.parse(reader.result);
                resolve(json);
              } catch (error) {
                reject(error);
              }
            };
            reader.onerror = reject;
            reader.readAsText(blob);
          });
        })
        .then((json:any) => {
          client.content.contentsShowTransfer({ id }).then((payload) => {
            if (json.transfer_batch_number != "") {
              usePDF().downloadPDF(json, payload.name, payload.depositedAt);
            } else {
              usePDF().downloadPDFwithoutData(
                json,
                payload.name,
                payload.depositedAt
              );
            }
          });
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error downloading or parsing transfer report:", error);
        });

// auth.getUser().then((user) => {
//     if (user) {
//       return user.access_token.toString(); // Convert the access token to a string
//     } else {
//       return ""; // Return an empty string if user is not available
//     }
//   })
//   .then((accessToken) => {
//     this.accessTokenString = accessToken; // Assign accessToken to accessTokenString for use outside of the Promise chain
//     this.loading = true;
//     fetch(
//       import.meta.env.VITE_SERVER_HOST +
//         "/contents/transfers/" +
//         id +
//         "/report?report_type=summary",
//       {
//         headers: {
//           Authorization: "" +   this.accessTokenString ,
//         },
//       }
//     )
//       .then((res) => {
//         client.content.contentsShowTransfer({ id }).then((payload) => {
//           res.json().then((json) => {
//             if (json.transfer_batch_number != "") {
//               usePDF().downloadPDF(json, payload.name, payload.depositedAt);
//             } else {
//               usePDF().downloadPDFwithoutData(
//                 json,
//                 payload.name,
//                 payload.depositedAt
//               );
//             }
//           });
//         });
//       })
//       .finally(() => (this.loading = false))
//       .catch((error) => {
//         return error;
//       });
//   })
//   .catch((error) => {
//     console.error("Error getting access token:", error);
//   });
    },

    async transferReportAppendix(id: string) {
      this.loading = true;

      client.content.contentsDownloadTransferReport({ id, reportType: "appendix" })
      .then((blob) => {
        client.content.contentsShowTransfer({ id }).then((payload) => {
          const url = window.URL.createObjectURL(blob);
          const name: any = payload.name;
          const a = document.createElement("a");
          a.href = url;
          a.download = "Report Details_" + name + ".csv";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
      })
      .finally(() => (this.loading = false))
      .catch((error) => {
        console.error("Error downloading transfer report:", error);
        const reportDetailsModal = new Modal("#reportDetailsModal");
        reportDetailsModal.show();
      });

      // fetch(
      //   import.meta.env.VITE_SERVER_HOST +
      //     "/contents/transfers/" +
      //     id +
      //     "/report?report_type=appendix",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      //   .then((res) => {
      //     if (res.status <= 299) {
      //       client.content.contentsShowTransfer({ id }).then((payload) => {
      //         res.blob().then((blob) => {
      //           const url = window.URL.createObjectURL(blob);
      //           const name: any = payload.name;
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = "Report Details_" + name + ".csv";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         });
      //       });
      //     } else {
      //       const reportDetailsModal = new Modal("#reportDetailsModal");
      //       reportDetailsModal.show();
      //     }
      //   })
      //   .finally(() => (this.loading = false))
      //   .catch((error) => {
      //     return error;
      //   });
    },

    async transferReportError(id: string) {
      this.loading = true;

      client.content.contentsDownloadTransferExceptionsReport({ id })
      .then((blob) => {

        console.log("blob", blob)
        if (blob instanceof Blob) {
          client.content.contentsShowTransfer({ id }).then((payload) => {
            const url = window.URL.createObjectURL(blob);
            const name: any = payload.name;
            const a = document.createElement("a");
            a.href = url;
            a.download = "Error Report_" + name + ".csv";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          });
        } else {
          console.error("Invalid response: Expected a Blob object");
        }
      })
      .finally(() => {
        this.loading = false;
      })
      .catch((error) => {
        console.error("Error downloading transfer exceptions report:", error);
        const errorReportModal = new Modal("#errorReportModal");
        errorReportModal.show();
      });
    

      // fetch(
      //   import.meta.env.VITE_SERVER_HOST +
      //     "/contents/transfers/" +
      //     id +
      //     "/exceptions/report",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      //   .then((res) => {
      //     if (res.status != 404) {
      //       client.content.contentsShowTransfer({ id }).then((payload) => {
      //         res.blob().then((blob) => {
      //           const url = window.URL.createObjectURL(blob);
      //           const name: any = payload.name;
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = "Error Report_" + name + ".csv";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         });
      //       });
      //     } else {
      //       const errorReportModal = new Modal("#errorReportModal");
      //       errorReportModal.show();
      //     }
      //   })
      //   .finally(() => (this.loading = false))
      //   .catch((error) => {
      //     return error;
      //   });
    },

    async fetchTransferReportList(
      perPage: number,
      sort: string,
      filters: Array<any>
    ) {
      this.loading = true;
      // console.log("starting: ", starting);
      client.content
        .contentsListTransferReports({
          transferBatchNumber: filters[0].filterText,
          transferringAgency: filters[1].filterText,
          limit: 1000,
          ordering: sort,
        })
        .then((payload) => {
          this.transferReportList = payload.items;
          this.totalTransferReports = payload.totalCount;
        })
        .finally(() => (this.loading = false))
        .catch((error) => {
          return error;
        });
    },

    async reprocessTransfer(id:string) {
      this.loading = true;
      client.content
        .contentsRecreateSips({id})
        .then((payload) => {
          console.log("reprocess transfer", payload)
        })
        .finally(() => {
          setTimeout(() => {
            this.fetchTransfer(id);
            this.loading = false;
          }, 2000);
        })
        .catch((error) => {
          return error;
        });
    },

    async resubmitTransfer(id: string) {
      this.loading = true;
      client.content
        .contentsResubmitTransfer({id})
        .then((payload) => {
          console.log("resubmit transfer", payload)
        })
        .finally(() => {
          setTimeout(() => {
            this.fetchTransfer(id);
            this.loading = false;
          }, 2000);
        })
        .catch((error) => {
          return error;
        });
    },

    async cancelTransfer(id: string) {
      this.loading = true;
      let errorMessage = "";
      let errorCode = "";
    
      try {
        const payload = await client.content.contentsCancelTransfer({ id });
        console.log("cancel transfer", payload);
      } catch (error:any) {
        if (error.response) {
          errorCode = error.response.status;
          try {
            const responseBody = await error.response.text();     
            try {
              const errorData = JSON.parse(responseBody); 
              errorMessage = errorData.message
            } catch (parseError) {
              errorMessage = 'An unexpected error occurred';
            }
          } catch (responseError) {
            errorMessage = 'Error reading the response body';
          }
        } else {
          errorMessage = 'An unexpected error occurred';
        }
      } finally {
        setTimeout(() => {
          this.fetchTransfer(id);
          this.loading = false;
        }, 2000);
      }
      if (errorMessage && (errorCode == '400')) {
        alert("This transfer cannot be cancelled due to the following reasons: " + errorMessage);
      }
    },

    async resubmitSip(id: string) {
      console.log("resubmit sip", id)
    },

    confirm(locationName: string) {},
    reject() {},
    reset() {
      this.currentTransfer = {};
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTransferStore, import.meta.hot));
}
